import { HTMLAttributes, MouseEventHandler } from 'react';
import { Checkbox } from '../Form/Checkbox';
import { CheckboxStatus } from '../../enums';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type SwitchProps = HTMLAttributes<HTMLButtonElement> & {
  id: string;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isActive?: boolean;
};

export const Switch = ({ id, label, onClick, disabled = false, isActive = false }: SwitchProps) => (
  <button
    className={joinClassNames(
      styles.switch,
      disabled ? styles.disabled : styles.default,
      isActive && styles.active
    )}
    onClick={onClick}
  >
    <Checkbox
      id={id}
      label={label}
      isSubcomponent
      statusCurrent={isActive ? CheckboxStatus.Checked : CheckboxStatus.Unchecked}
      disabled={disabled}
    />
  </button>
);
